import script from "/app/pages/Settings.vue?type=script";
import { render } from "/app/pages/Settings.vue?type=template";
script.render = render;
export default script;
